class StickyAddToBag {
	constructor(options = {}) {
		this.config = {
			originalButtonSelector:
				options.originalButtonSelector || "#add-to-bag-btn",
			zIndex: options.zIndex || 9999,
			buffer: options.buffer || 0,
		};

		this.originalButton = null;
		this.stickyContainer = null;
		this.isStickyVisible = false;
		this.hasScrolledPastButton = false; // Track if user has seen the button
		this.isBlocked = false;

		this.init();
	}

	init() {
		// Find the original button
		this.originalButton = document.querySelector(
			this.config.originalButtonSelector
		);
		if (!this.originalButton) {
			console.warn("StickyAddToBag: original button not found");
			return;
		}

		// Create sticky container
		this.createSticky();

		// Bind scroll and resize
		this.bindEvents();

		// Initial update
		this.updateSticky();
	}

	createSticky() {
		this.stickyContainer = document.createElement("div");
		this.stickyContainer.className = "sticky-add-to-bag-container";

		// Clone original button
		const clone = this.originalButton.cloneNode(true);
		clone.removeAttribute("id");
		clone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
		clone.classList.add("sticky-add-to-bag");

		this.stickyContainer.appendChild(clone);
		document.body.appendChild(this.stickyContainer);

		// Apply styles
		this.stickyContainer.style.cssText = `
			position: fixed;
			left: 0;
			right: 0;
			bottom: 0;
			display: flex;
			justify-content: center;
			background: #fff;
			z-index: ${this.config.zIndex};
			transform: translateY(100%);
			transition: transform 0.25s ease;	
		`;

		clone.addEventListener("click", (e) => {
			e.preventDefault();

			// Trigger original button click
			this.originalButton.click();

			// Scroll to first invalid field if there is one
			const firstInvalid = document.querySelector(":invalid");
			if (firstInvalid) {
				const offset = 80; // optional offset for sticky height
				const y =
					firstInvalid.getBoundingClientRect().top + window.scrollY - offset;

				window.scrollTo({ top: y, behavior: "smooth" });

				// Focus field without scrolling again
				firstInvalid.focus({ preventScroll: true });
			}
		});
	}

	bindEvents() {
		let ticking = false;

		this.scrollHandler = () => {
			if (!ticking) {
				requestAnimationFrame(() => {
					this.updateSticky();
					ticking = false;
				});
				ticking = true;
			}
		};

		window.addEventListener("scroll", this.scrollHandler, { passive: true });
		window.addEventListener("resize", this.scrollHandler, { passive: true });

		if (window.visualViewport) {
			window.visualViewport.addEventListener("resize", this.scrollHandler);
			window.visualViewport.addEventListener("scroll", this.scrollHandler);
		}
	}

	updateSticky() {
		const button = document.querySelector(this.config.originalButtonSelector);

		if (!button) {
			console.warn("Button lost during scroll!");
			return;
		}

		const rect = button.getBoundingClientRect();
		const viewportHeight = window.visualViewport?.height || window.innerHeight;
		const scrollY = window.pageYOffset || document.documentElement.scrollTop;

		// Fallback calculations if getBoundingClientRect fails
		let isAboveViewport, isBelowViewport, isInViewport;

		if (rect.width === 0 && rect.height === 0) {
			// Use offset calculations
			const buttonOffsetTop = button.offsetTop;
			const buttonHeight = button.offsetHeight;
			const buttonTopRelativeToViewport = buttonOffsetTop - scrollY;
			const buttonBottomRelativeToViewport =
				buttonOffsetTop + buttonHeight - scrollY;

			isAboveViewport = buttonBottomRelativeToViewport < this.config.buffer;
			isBelowViewport =
				buttonTopRelativeToViewport > viewportHeight - this.config.buffer;
			isInViewport = !isAboveViewport && !isBelowViewport;
		} else {
			// Normal calculations
			isAboveViewport = rect.bottom <= this.config.buffer;
			isBelowViewport = rect.top >= viewportHeight - this.config.buffer;
			isInViewport = rect.top < viewportHeight && rect.bottom > 0;
		}

		// Track if user has ever scrolled past the button (seen it)
		if (isInViewport || isAboveViewport) {
			this.hasScrolledPastButton = true;
		}

		// Only show sticky if:
		// 1. User has scrolled past the button at least once
		// 2. Button is currently above the viewport
		const shouldShow = this.hasScrolledPastButton && isAboveViewport;

		if (this.isBlocked) {
			if (this.isStickyVisible) {
				this.hideSticky();
			}
			return;
		}

		if (shouldShow && !this.isStickyVisible) {
			this.showSticky();
		} else if (!shouldShow && this.isStickyVisible) {
			this.hideSticky();
		}
	}

	showSticky() {
		this.isStickyVisible = true;
		this.stickyContainer.style.transform = "translateY(0)";
	}

	hideSticky() {
		this.isStickyVisible = false;
		this.stickyContainer.style.transform = "translateY(100%)";
	}

	destroy() {
		window.removeEventListener("scroll", this.scrollHandler);
		window.removeEventListener("resize", this.scrollHandler);

		if (window.visualViewport) {
			window.visualViewport.removeEventListener("resize", this.scrollHandler);
			window.visualViewport.removeEventListener("scroll", this.scrollHandler);
		}

		if (this.stickyContainer) {
			this.stickyContainer.remove();
		}
	}

	block() {
		this.isBlocked = true;
		this.hideSticky();
	}

	unblock() {
		this.isBlocked = false;
		this.updateSticky();
	}
}

// Export as ES module
export default StickyAddToBag;


// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/sticky-add-to-bag.js